// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/scorer.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Enumerates different HTTP methods.
 *
 * @generated from enum ai.h2o.deploy.HttpMethod
 */
export const HttpMethod = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.HttpMethod",
  [
    {no: 0, name: "HTTP_METHOD_UNSPECIFIED"},
    {no: 1, name: "GET"},
    {no: 2, name: "POST"},
  ],
);

/**
 * @generated from enum ai.h2o.deploy.ScorerType
 */
export const ScorerType = /*@__PURE__*/ proto3.makeEnum(
  "ai.h2o.deploy.ScorerType",
  [
    {no: 0, name: "SCORER_TYPE_UNSPECIFIED"},
    {no: 1, name: "MOJO2_REST_SCORER"},
  ],
);

/**
 * Defines types and known API of a deployed scorer.
 *
 * @generated from message ai.h2o.deploy.Scorer
 */
export const Scorer = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Scorer",
  () => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(ScorerType) },
    { no: 2, name: "score", kind: "message", T: Endpoint },
    { no: 3, name: "sample_request", kind: "message", T: Endpoint },
    { no: 4, name: "capabilities", kind: "message", T: Endpoint },
    { no: 5, name: "internal_service", kind: "message", T: Endpoint },
  ],
);

/**
 * @generated from message ai.h2o.deploy.Endpoint
 */
export const Endpoint = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.Endpoint",
  () => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "method", kind: "enum", T: proto3.getEnumType(HttpMethod) },
  ],
);

